import { Observable, of } from 'rxjs';
import { filter, find, findIndex } from 'lodash-es';
import { delay } from 'rxjs/operators';
import { ObjectUtil } from '../util/object.util';
import { PageCriteria } from '../model/local/pagination/page-criteria';

export class MockService<T, PageType> {
  constructor(private data: any[]) {}

  public getAll(): Observable<T[]> {
    this.log('Get all');
    return of(this.data as T[]);
  }

  public getPage(criteria: PageCriteria): Observable<PageType> {
    let data;

    if (criteria.searchPhrase) {
      data = this.data
        .map(item => {
          return {
            mergedData: Object.keys(item)
              .map(key => String(item[key]).toLowerCase())
              .join(','),
            element: item,
          };
        })
        .filter(
          item =>
            item.mergedData.indexOf(criteria.searchPhrase!.toLowerCase()) > -1
        )
        .map(item => item.element);
    } else {
      data = this.data.filter(s => !criteria.excludedIds?.includes(s.id));
    }

    const sliced = data.slice(
      criteria.pageNumber * criteria.pageSize,
      criteria.pageNumber * criteria.pageSize + criteria.pageSize
    );

    const result = {
      number: criteria.pageNumber,
      content: sliced,
      totalElements: data.length,
      numberOfElements: sliced.length,
      totalPages: data.length / criteria.pageSize,
    } as PageType;

    this.log('Get page', {
      criteria: ObjectUtil.instanceToPlain(criteria),
      result,
    });

    return of(result).pipe(delay(1000));
  }

  public getById(id: number): Observable<T> {
    this.log('Get by id', id);
    const result = find(this.data, { id: +id });

    return of(result);
  }

  public getFirst(): Observable<T> {
    return of(this.data[0]);
  }

  public create(data: T): Observable<T> {
    this.log('Create', ObjectUtil.instanceToPlain(data));

    // @ts-ignore
    data.id = this.data.length + 1;
    this.data.unshift(data);

    return of(data);
  }

  public createBulk(data: T[]): Observable<T[]> {
    this.log('Create bulk', data);

    const number = this.data.length + 1;
    // @ts-ignore
    data.forEach((d: T, index: number) => (d.id = number + index));

    this.data = [...data, ...this.data];

    return of(data);
  }

  public update(id: number, data: T): Observable<T> {
    this.log('Update', data);

    // @ts-ignore
    const index = findIndex(this.data, { id });

    this.data[index] = data;

    return of(data);
  }

  public patchData(id: number, data: any): Observable<T> {
    this.log('Patch data', { id, data });

    // @ts-ignore
    const index = findIndex(this.data, { id });
    const patched = {
      ...this.data[index],
      ...data,
    } as T;

    this.data[index] = patched;

    return of(patched);
  }

  public updateBulk(data: T[]): Observable<T[]> {
    this.log('Update bulk', data);

    return this.createBulk(data);
  }

  public delete(id: number): Observable<void> {
    this.log('Delete', id);

    // @ts-ignore
    this.data = filter(this.data, (item: any) => item.id !== id);
    return of(void 0);
  }

  private log(value: string, payload?: any): void {
    console.groupCollapsed(
      `%c [Mock service] ${value}`,
      'background: #222; color: #bada55'
    );

    if (payload) {
      console.log('Payload: ', payload);
    }

    console.groupEnd();
  }
}
